import { TrialIds } from 'purchase-motions-components/constants/trial';
import { getRouteParams } from '../routing/getRouteParams';
import { TrialId, TrialToHubInterestOption } from './trialConstants';
export const TRIAL_ID = 'trialid';
export const parseTrialId = trialId => {
  return trialId && parseInt(trialId, 10);
};
const sanitizeSearch = search => {
  let sanitized = search;
  let prev = '';
  while (sanitized !== prev) {
    prev = sanitized;
    sanitized = sanitized.replace(/&amp;/gi, '&');
  }
  return sanitized;
};
export const getParsedTrialId = () => {
  const {
    search
  } = getRouteParams();
  const sanitizedSearch = sanitizeSearch(search).toLowerCase();
  const queryParamsMap = new URLSearchParams(sanitizedSearch);
  const trialdIdQueryParam = queryParamsMap.get(TRIAL_ID);
  const parsedTrialId = parseTrialId(trialdIdQueryParam);
  return parsedTrialId;
};
export const isValidTrialId = trialId => Object.values(TrialId).includes(trialId);
export const isAeoStandaloneTrialId = trialId => trialId === TrialIds.AEO_STANDALONE;
export const getHubInterestOptionForTrial = () => {
  const trialId = getParsedTrialId();
  if (trialId) {
    return TrialToHubInterestOption.get(trialId);
  }
  return null;
};